<template>
  <div>
    <icon-view
      gradient
      class="mr-2 mt-3 mb-4 rounded-circle icon-view-color-text"
      icon="fas fa-phone-alt color-orange mb-1"
      title="Información del Contacto"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
    />
    <div class="row my-2">
      <div class="col-md">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            id="input-contact-organizer"
            label="Organizador(a):"
            type="text"
            maxlength="200"
            v-model="model.organizer"
            :error="errors[0]"
            custom-error-msg="El organizador(a) es requerido(a)."
            :disabled="readOnly"
          >
          </custom-input>
        </validation-provider>
      </div>
      <div class="col-md">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            id="input-contact-phone"
            label="Telefóno:"
            mask-type="Phone"
            placeholder="(___)-___-____"
            v-model="model.phone"
            :error="errors[0]"
            custom-error-msg="El telefóno es requerido."
            :disabled="readOnly"
          >
          </custom-input>
        </validation-provider>
      </div>
      <div class="col-md">
        <validation-provider
          v-slot="{ errors }"
          rules="required|email"
          :custom-messages="{
            required: 'Favor de ingresar un correo electrónico.',
            email: 'Favor de entrar un correo electrónico válido.'
          }"
        >
          <custom-input
            id="input-contact-email"
            label="Correo Electrónico: "
            type="email"
            maxlength="200"
            v-model="model.email"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
    </div>
    <div class="my-2">
      <validation-provider v-slot="{ errors }" rules="required">
        <custom-input
          id="input-contact-location"
          label="Ubicación:"
          type="text"
          v-model="model.locationText"
          custom-error-msg="La ubicación es requerida."
          :error="errors[0]"
          :disabled="readOnly"
        >
        </custom-input>
      </validation-provider>
    </div>
    <validation-provider v-slot="{ errors }" rules="required">
      <custom-input
        id="input-contact-map-link"
        label="Insertar URL de mapa para publicar el enlace de la dirección en línea:"
        type="text"
        v-model="model.locationUrl"
        custom-error-msg="La URL es requerida."
        :error="errors[0]"
        :disabled="readOnly"
      >
      </custom-input>
    </validation-provider>
  </div>
</template>

<script>
import IconView from "icon-view";
import { ValidationProvider } from "vee-validate";
import CustomInput from "CustomInput";
import TYPES from "@/utils/constants/operations-dashboard-management/scheduleItemTypes";

export default {
  name: "ContactInfo",
  components: {
    IconView,
    CustomInput
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    readOnly:{
      type: Boolean,
      default: () => false
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
